import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pdf-light-theme',
  templateUrl: './pdf-light-theme.component.html',
  styleUrls: ['colors.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PdfLightThemeComponent {}
